import { render, staticRenderFns } from "./QuestionsAdmin.vue?vue&type=template&id=7597e27f&scoped=true&"
import script from "./QuestionsAdmin.vue?vue&type=script&lang=js&"
export * from "./QuestionsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597e27f",
  null
  
)

export default component.exports